import type {
  DisplayDoc,
  DisplayUser,
  DisplayUserFollow,
  PublicUserProfile,
  UserSearchResult,
} from '@/lib/api';

import type { Identity } from './types';

/** Adapts DisplayUser to the canonical Identity shape. */
export function identityFromDisplayUser(
  user: Pick<DisplayUser, 'username' | 'fullname' | 'avatar'>
): Identity {
  return {
    username: user.username,
    fullname: user.fullname,
    avatarUrl: user.avatar?.url ?? null,
  };
}

/** Adapts DisplayUserFollow to the canonical Identity shape. */
export function identityFromDisplayUserFollow(follow: DisplayUserFollow): Identity {
  return {
    username: follow.username,
    avatarUrl: follow.avatar?.url ?? null,
  };
}

/** Adapts UserSearchResult to the canonical Identity shape. */
export function identityFromUserSearchResult(result: UserSearchResult): Identity {
  return {
    username: result.username,
    fullname: result.fullname,
    avatarUrl: result.avatar?.url ?? null,
  };
}

/** Adapts PublicUserProfile to the canonical Identity shape. */
export function identityFromPublicUserProfile(profile: PublicUserProfile): Identity {
  return {
    username: profile.username,
    fullname: profile.fullname,
    avatarUrl: profile.avatar?.url ?? null,
  };
}

/** Adapts document provenance to the canonical Identity shape. */
export function identityFromDocProvenance(
  provenance: Pick<DisplayDoc['provenance'], 'creator' | 'avatar'>
): Identity {
  return {
    username: provenance.creator,
    avatarUrl: provenance.avatar?.url ?? null,
  };
}
